 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>
            阶段控制参数
            <el-tooltip
              class="item"
              effect="dark"
              content="以空气温度为例，当前棚内植物最佳生长环境空气温度为20℃~25℃，阶段控制参数为-10~0,0~10，则将空气划分为两个空气温度控制区间，10℃~20℃，25℃~35℃，当前空气温度落入对应的阶段控制区间时会触发不同的控制设备对空气温度进行调控。"
              placement="top"
            >
              <i
                class="el-icon-question"
                style="color: #409eff; margin-left: 5px"
              ></i>
            </el-tooltip>
          </h4>
          <el-button type="primary" class="adduser" @click="handleAdd"
            >添加</el-button
          >
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" :label="'开始阶段' + paramUnit">
              <template slot-scope="scope">
                <p>{{ scope.row.startStage }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'结束阶段' + paramUnit">
              <template slot-scope="scope">
                <p>{{ scope.row.endStage }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleDevice(scope.row)"
                  type="text"
                  size="small"
                  >设备</el-button
                >
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="开始阶段：" prop="startStage">
                  <el-input-number
                    v-model="ruleForm.startStage"
                    placeholder="请输入开始阶段"
                    :min="-99999999"
                    :max="99999999"
                    :precision="2"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="结束阶段：" prop="endStage">
                  <el-input-number
                    v-model="ruleForm.endStage"
                    placeholder="请输入开始阶段"
                    :min="-99999999"
                    :max="99999999"
                    :precision="2"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="单次检测时间：" prop="checkTime">
                  <el-input-number
                    v-model="ruleForm.checkTime"
                    placeholder="请输入单次检测时间（s）"
                    :min="0"
                    :max="99999999"
                    :precision="0"
                    :step="1"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="总共检测时间：" prop="totalCheckTime">
                  <el-input-number
                    v-model="ruleForm.totalCheckTime"
                    placeholder="请输入总共检测时间（s）"
                    :min="0"
                    :max="99999999"
                    :precision="0"
                    :step="1"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        paramId: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        paramId: "",
        startStage: "",
        endStage: "",
        // checkTime: "",
        // totalCheckTime: "",
      },
      rules: {
        // 添加编辑表单规则
        startStage: [
          {
            required: true,
            message: "请输入开始阶段",
            trigger: "blur",
          },
        ],
        endStage: [
          {
            required: true,
            message: "请输入结束阶段",
            trigger: "blur",
          },
        ],
        // checkTime: [
        //   {
        //     required: true,
        //     message: "请输入单次检测时间",
        //     trigger: "blur",
        //   },
        // ],
        // totalCheckTime: [
        //   {
        //     required: true,
        //     message: "请输入总共检测时间（s）",
        //     trigger: "blur",
        //   },
        // ],
      },
      paramId: "", // 生长模型环境参数ID
      addEditTitle: "添加阶段控制参数", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      paramUnit: "", // 参数单位
    };
  },
  created() {
    this.searchForm.paramId = this.$route.query.paramId;
    this.ruleForm.paramId = this.$route.query.paramId;
    this.paramId = this.$route.query.paramId;
    this.paramUnit = "（" + this.$route.query.paramUnit + "）";

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        paramId: this.paramId,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelStageControlList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel
            .delGrowthModelStageControl(row.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.getList();
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑阶段控制参数";
      this.ruleForm.id = row.id;
      this.ruleForm.modelId = this.paramId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelStageControl({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = res.data;
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加阶段控制参数";
      this.ruleForm.id = "";
      this.ruleForm.modelId = this.paramId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelStageControl(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 设备
    handleDevice(row) {
      this.$router.push({
        name: `growthModelStageControlDeviceManagement`,
        query: {
          stageControlId: row.id,
          stageControlName: this.$route.query.paramName + "_阶段控制参数",
          paramId: this.$route.query.paramId,
          paramType: this.$route.query.paramType,
          paramName: this.$route.query.paramName,
          paramUnit: this.$route.query.paramUnit,
          evnId: this.$route.query.evnId,
          evnName: this.$route.query.evnName,
          groupId: this.$route.query.groupId,
          controlType: this.$route.query.controlType,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>